import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";


const Slider = ({ values }) => {
  const carouselSettings = {
    showStatus: false,
    showThumbs: false,
    infiniteLoop: false,
    swipeScrollTolerance: 120,
    swipeable: true,
    emulateTouch: true,
    verticalSwipe: "natural",
    showIndicators: values.length > 1,
  };

  return (
    <Carousel {...carouselSettings}>
      {values.map((value, index) => (
          <a className="slider__link" href={value.url} key={`figure${index}`} target={value.urltarget}>
          <img
            className="slider__image hide-for-small-only"
            src={value.image}
          />
          <img
            className="slider__image hide-for-medium"
            src={value.imagemobile || value.image}
          />
          <div
            className={`slider__content slider__content--${value.position || "center"}`}
          >
            <div className={`slider__content__content-inner text-${value.textcolor || "white"}`}>
              <h2 className={`slider__content__header`}>{value.header}</h2>
              <p className={`slider__content__text`}>{value.text}</p>
              {value.buttontext && (
                <div className="slider__content__button">
                  <div href={value.url} className="slider__content__button-text">
                    {value.buttontext}
                  </div>
                </div>
              )}
            </div>
          </div>
        </a>
      ))}
    </Carousel>
  );
};

export default Slider;
